import { Box, Button, FormControl, FormControlLabel, Grid, IconButton, InputAdornment, Radio, RadioGroup, Tooltip, Typography } from "@mui/material";
import React, { useCallback } from "react";
import TextField from "../../../components/FormComponents/TextField";
import MUIDatePicker from "../../../components/FormComponents/DatePicker";
import { useTranslation } from "react-i18next";
import AutocompleteField from "../../../components/FormComponents/AddressAutofill";
import constants, { CANADA_PROVINCES, COMPANY_TYPE, COUNTRY_LIST, singupAdditionalInfoFields, TaxExempt, USA_STATES } from "../../../config/constants";
import { getStateOptionsForCountry, isValidSSNOrFedTaxId, SSN_FED_TAX_ID_LENGTH } from "../../../utils/commonUtilities";
import AutoCompleteDD from "../../../components/FormComponents/AutoCompleteDD";
import moment from "moment";
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useSelector } from "react-redux";
export const initial_additionalInfo = {
    FirstName: '',
    LastName: '',
    CustCountry: '',
    CustState: '',
    Country: '',
    State: '',
    City: '',
    PostalCode: '',
    Address: '',
    Suffix: '',
    BusinessIncorporatedDate: '',
    CompanyDesc: '',
    CompanyCode: '',
    DOB: '',
    SSN: '',
    DBAName: '',
    BusinessTitle: '',
    LegalRegName: '',
    BusOrInd: 'B',
    isAddressSelectedFromMaps: false,
    __custStateOptions: [],
    __stateOptions: []
};
const AdditionalInformation = (props) => {
    var _a, _b, _c, _d, _e;
    const { handleSave, handleBack, prevProps } = props;
    const [t] = useTranslation('global');
    const vendorConfig = useSelector((state) => state.vendor.vendorDetails);
    const [additionalInfo, setAdditionalInfo] = React.useState(Object.assign({}, initial_additionalInfo));
    const [additionalInfoErrors, setAdditionalInfoErrors] = React.useState({
        FirstName: '',
        LastName: '',
        CustCountry: '',
        CustState: '',
        Country: '',
        State: '',
        City: '',
        PostalCode: '',
        Address: '',
        Suffix: '',
        BusinessIncorporatedDate: '',
        CompanyCode: '',
        DOB: '',
        SSN: '',
        DBAName: '',
        BusinessTitle: '',
        LegalRegName: '',
    });
    const [defaultDateError, setDefaultDateError] = React.useState('');
    React.useEffect(() => {
        var _a;
        if (prevProps && ((_a = Object.values(prevProps)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setAdditionalInfo(Object.assign(Object.assign({}, prevProps), { __custStateOptions: getStateOptionsForCountry(prevProps === null || prevProps === void 0 ? void 0 : prevProps.CustCountry), __stateOptions: getStateOptionsForCountry(prevProps === null || prevProps === void 0 ? void 0 : prevProps.Country) }));
        }
    }, [prevProps]);
    const handlePreviousStep = () => {
        handleBack(0, additionalInfo);
    };
    const handleSubmit = () => {
        let updatedErrors = Object.assign({}, additionalInfoErrors);
        let _isValidCustomer = true;
        for (const key in additionalInfoErrors) {
            if ((additionalInfo.BusOrInd === 'I' && !['LegalRegName', 'CompanyCode', 'CompanyDesc', 'CustCountry', 'CustState', 'TaxExempt', 'DBAName'].includes(key)) ||
                (additionalInfo.BusOrInd === 'B' && !['FirstName', 'LastName', 'DOB', 'DBAName'].includes(key))) {
                const errorMsg = validateField(key, additionalInfo[key]);
                updatedErrors[key] = errorMsg;
                if (errorMsg) {
                    _isValidCustomer = false;
                }
            }
        }
        setAdditionalInfoErrors(updatedErrors);
        if (_isValidCustomer) {
            handleSave(additionalInfo);
        }
    };
    const handleCountryChange = (name, value) => {
        let __additionalInfo = Object.assign({}, additionalInfo);
        __additionalInfo[name] = value;
        if (name === 'CustCountry' && value === COUNTRY_LIST[0].code) {
            __additionalInfo['CustState'] = '',
                __additionalInfo['__custStateOptions'] = USA_STATES;
        }
        else if (name === 'CustCountry' && value === COUNTRY_LIST[1].code) {
            __additionalInfo['CustState'] = '',
                __additionalInfo['__custStateOptions'] = CANADA_PROVINCES;
        }
        else if (name === 'Country' && value === COUNTRY_LIST[0].code) {
            __additionalInfo['State'] = '',
                __additionalInfo['__stateOptions'] = USA_STATES;
        }
        else if (name === 'Country' && value === COUNTRY_LIST[1].code) {
            __additionalInfo['State'] = '',
                __additionalInfo['__stateOptions'] = CANADA_PROVINCES;
        }
        setAdditionalInfo(__additionalInfo);
    };
    const handleOnValChange = (e) => {
        let { name, value } = e.target;
        let __additionalInfo = Object.assign({}, additionalInfo);
        let __additionalInfoErrors = Object.assign({}, additionalInfoErrors);
        if (name === 'BusOrInd') {
            __additionalInfo = Object.assign(Object.assign({}, initial_additionalInfo), { BusOrInd: value });
            __additionalInfoErrors = Object.assign({}, initial_additionalInfo);
        }
        if (name === 'PhoneNumber' || name === 'BillingPhoneNumber') {
            value = value === null || value === void 0 ? void 0 : value.replace(constants.regex.PhoneNumber, '');
        }
        if (name === 'SSN') {
            value = value === null || value === void 0 ? void 0 : value.replace(constants.regex.SSN_PostalCode, '');
        }
        if (name === 'PostalCode' || name === 'BillingPostalCode') {
            value = value === null || value === void 0 ? void 0 : value.replace(constants.regex.SSN_PostalCode, '');
        }
        if (name === 'CustCountry' || name === 'Country' || name === 'BillingCountry') {
            handleCountryChange(name, value);
            return;
        }
        if (name === 'CompanyCode') {
            const companyDescription = COMPANY_TYPE.filter((item) => item.Code === value)[0].Description;
            __additionalInfo['CompanyDesc'] = companyDescription;
        }
        __additionalInfo[name] = value;
        if (name === 'Country' || name === 'State' || name === 'City' || name === 'Address' || name === 'PostalCode') {
            __additionalInfo['__isAddressVerified'] = false;
        }
        setAdditionalInfo(__additionalInfo);
        setAdditionalInfoErrors(__additionalInfoErrors);
    };
    const handleDateChange = (key, value) => {
        const selectedDate = moment(value).format(constants.US_DATE_FORMAT);
        const parsedDate = moment(selectedDate, constants.US_DATE_FORMAT, true);
        if (key === 'DOB') {
            if (parsedDate) {
                const eighteenYearsAgo = moment().subtract(18, 'years');
                if (parsedDate.isValid() && parsedDate.isBefore(eighteenYearsAgo)) {
                    setAdditionalInfo((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: selectedDate })));
                    setAdditionalInfoErrors((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: '' })));
                    setDefaultDateError('');
                }
                else {
                    setAdditionalInfoErrors((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: t('CREATE_NOR_LOC_APP.customer_info.ERR_INVALID_AGE') })));
                    setDefaultDateError(t('CREATE_NOR_LOC_APP.customer_info.ERR_INVALID_AGE'));
                    return;
                }
            }
        }
        if (parsedDate.isValid() && parsedDate.isBetween(moment('01/01/1000', constants.US_DATE_FORMAT), moment('12/31/9999', constants.US_DATE_FORMAT)) && value != null) {
            setAdditionalInfo((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: selectedDate })));
            setAdditionalInfoErrors((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: '' })));
            setDefaultDateError('');
        }
        else {
            setAdditionalInfoErrors((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: t('CREATE_NOR_LOC_APP.customer_info.ERR_INVALID_DATE') })));
            setDefaultDateError(t('CREATE_NOR_LOC_APP.customer_info.ERR_INVALID_DATE'));
        }
        if (value == null) {
            setAdditionalInfo((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: null })));
            setAdditionalInfoErrors((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: '' })));
            setDefaultDateError('');
        }
    };
    const handleOnInputBlur = (e) => {
        const { name, value } = e.target;
        setAdditionalInfoErrors((prevState) => (Object.assign(Object.assign({}, prevState), { [name]: validateField(name, value) })));
    };
    const validateField = (fieldName = 'all', value) => {
        if (fieldName === 'CurrentOwnerShipDate' || fieldName === 'TaxExempt')
            return '';
        if ((fieldName === 'BusinessIncorporatedDate' && defaultDateError === t('CREATE_NOR_LOC_APP.customer_info.ERR_INVALID_DATE'))) {
            return defaultDateError;
        }
        if (fieldName === 'BusinessIncorporatedDate')
            return defaultDateError;
        if ((fieldName === 'DBAName' || fieldName === 'MiddleName' || fieldName === 'BusinessTitle' || fieldName === 'Suffix') && !value) {
            return '';
        }
        if (fieldName === 'FirstName' || fieldName === 'LastName') {
            if (additionalInfo.BusOrInd === 'I') {
                if (!(value === null || value === void 0 ? void 0 : value.trim())) {
                    return t('GENERIC_STRINGS.RequiredField');
                }
            }
        }
        if (!value) {
            return t('GENERIC_STRINGS.RequiredField');
        }
        if ((fieldName === 'Email' || fieldName === 'BillingEmail') && !constants.regex.emailRegExp.test(value)) {
            return t('CREATE_NOR_LOC_APP.customer_info.ERR_VALID_EMAIL');
        }
        if ((fieldName === 'PhoneNumber' || fieldName === 'BillingPhoneNumber') && value && value.length < 10) {
            return t('CREATE_NOR_LOC_APP.customer_info.ERR_VALID_PHONE');
        }
        if (fieldName === 'SSN' && value) {
            const _err = (additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.BusOrInd) === 'B' ? t('CREATE_NOR_LOC_APP.GUR_INFO.ERR_VALID_FAD_TAX') : t('CREATE_NOR_LOC_APP.GUR_INFO.ERR_VALID_SSN');
            return !isValidSSNOrFedTaxId(value) ? _err : '';
        }
        return '';
    };
    const getDropdownOptions = (fieldName) => {
        switch (fieldName) {
            case "Country":
            case "CustCountry":
            case "BillingCountry":
                return COUNTRY_LIST;
            case "CustState":
                return additionalInfo['__custStateOptions'];
            case "State":
                return additionalInfo['__stateOptions'];
            default:
                return [];
        }
    };
    const getFormFieldRegEx = (fieldName) => {
        switch (fieldName) {
            case 'SSN':
            case 'PostalCode':
            case 'BillingPostalCode':
                return constants.regex.SSN_PostalCode;
            case 'PhoneNumber':
            case 'BillingPhoneNumber':
                return constants.regex.PhoneNumber;
            default:
                return '';
        }
    };
    const getFormFieldInputMaxLength = (fieldName) => {
        switch (fieldName) {
            case 'FirstName':
            case 'LastName':
                return 30;
            case 'MiddleName':
                return 20;
            case 'SSN':
                return SSN_FED_TAX_ID_LENGTH;
            case 'Address':
            case 'BillingAddress':
                return 100;
            case "Email":
                return 60;
            case "BillingEmail":
                return 100;
            case "PhoneNumber":
            case "BillingPhoneNumber":
                return 10;
            case 'PostalCode':
            case 'BillingPostalCode':
                return 9;
            default:
                return 50;
        }
    };
    const handlePlaceSelected = (place, fieldName, index, isAddressSelected, isBiilingAddressSelected, customerObj) => {
        const addressType = fieldName === 'Address' ? '' : 'Billing';
        setAdditionalInfo((prevAdditionalInfo) => {
            let __additionalInfo = Object.assign({}, prevAdditionalInfo);
            if ((fieldName === 'Address' && isAddressSelected) || (fieldName === 'BillingAddress' && isBiilingAddressSelected)) {
                if (place && place.address_components) {
                    const { address_components } = place;
                    const newAddressDetails = {
                        [`${addressType}Address`]: '',
                        [`${addressType}State`]: null,
                        [`${addressType}StateCode`]: null,
                        [`${addressType}City`]: '',
                        [`${addressType}Country`]: null,
                        [`${addressType}CountryCode`]: null,
                        [`${addressType}PostalCode`]: '',
                        ['isAddressSelectedFromMaps']: isAddressSelected,
                        ['__isAddressVerified']: isAddressSelected,
                        ['__stateOptions']: additionalInfo['__stateOptions'],
                    };
                    address_components.forEach((component) => {
                        var _a;
                        const componentType = (_a = component.types) === null || _a === void 0 ? void 0 : _a.find((item) => item !== 'political');
                        const longName = component.long_name;
                        const shortName = component.short_name;
                        switch (componentType) {
                            case 'street_number':
                            case 'route':
                                newAddressDetails[`${addressType}Address`] += `${longName} `;
                                break;
                            case 'locality':
                                newAddressDetails[`${addressType}City`] = longName;
                                break;
                            case 'sublocality':
                                if (!newAddressDetails[`${addressType}City`]) {
                                    newAddressDetails[`${addressType}City`] = longName;
                                }
                                break;
                            case 'administrative_area_level_1':
                                newAddressDetails[`${addressType}State`] = shortName;
                                newAddressDetails[`${addressType}StateCode`] = shortName;
                                break;
                            case 'country':
                                newAddressDetails[`${addressType}CountryCode`] = shortName;
                                if (fieldName === 'Address') {
                                    if (shortName === 'US') {
                                        newAddressDetails[`${addressType}Country`] = 'USA';
                                        newAddressDetails.__stateOptions = [...USA_STATES];
                                    }
                                    else if (shortName === 'CA') {
                                        newAddressDetails[`${addressType}Country`] = 'CAN';
                                        newAddressDetails.__stateOptions = [...CANADA_PROVINCES];
                                    }
                                }
                                else {
                                    if (shortName === 'US') {
                                        newAddressDetails[`${addressType}Country`] = 'USA';
                                        newAddressDetails.__billingStateOptions = [...USA_STATES];
                                    }
                                    else if (shortName === 'CA') {
                                        newAddressDetails[`${addressType}Country`] = 'CAN';
                                        newAddressDetails.__billingStateOptions = [...CANADA_PROVINCES];
                                    }
                                }
                                break;
                            case 'postal_code':
                                newAddressDetails[`${addressType}PostalCode`] = longName;
                                break;
                            default:
                                break;
                        }
                    });
                    __additionalInfo = Object.assign(Object.assign({}, __additionalInfo), newAddressDetails);
                    return __additionalInfo;
                }
            }
            return prevAdditionalInfo;
        });
    };
    const getSelectedStateObject = useCallback((dropDownCode, type, options) => {
        if (dropDownCode && type === 'CustState') {
            options = additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo['__custStateOptions'];
            const stateObj = options === null || options === void 0 ? void 0 : options.find((custStateObject) => custStateObject.code === dropDownCode);
            return stateObj;
        }
        if (dropDownCode && type === 'State') {
            options = additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo['__stateOptions'];
            const stateObj = options === null || options === void 0 ? void 0 : options.find((addrsStateObject) => addrsStateObject.code === dropDownCode);
            return stateObj;
        }
        if (dropDownCode && type === 'CompanyCode') {
            const entityType = options === null || options === void 0 ? void 0 : options.find((entityObj) => entityObj.Code === dropDownCode);
            return entityType;
        }
        if (dropDownCode && type === 'Country') {
            const country = COUNTRY_LIST.find((countryObj) => countryObj.code === dropDownCode);
            return country;
        }
        if (dropDownCode && type === 'CustCountry') {
            const country = COUNTRY_LIST.find((countryObj) => countryObj.code === dropDownCode);
            return country;
        }
        if (dropDownCode && type === 'BillingCountry') {
            const country = COUNTRY_LIST.find((countryObj) => countryObj.code === dropDownCode);
            return country;
        }
        if (dropDownCode && type === 'TaxExempt') {
            const taxExempt = TaxExempt.find((taxObj) => taxObj.value === dropDownCode);
            return taxExempt;
        }
        if (dropDownCode && type === 'Suffix') {
            const suffix = options === null || options === void 0 ? void 0 : options.find((suffixObj) => suffixObj.value === dropDownCode);
            return suffix;
        }
        return dropDownCode;
    }, [additionalInfo]);
    const getFormFieldToRender = (formObj) => {
        var _a, _b, _c;
        let id = formObj.apiFieldName === 'Address' ? 'Address' : 'BillingAddress';
        switch (formObj.type) {
            case 'text':
                if (formObj.apiFieldName === 'Address' || formObj.apiFieldName === 'BillingAddress') {
                    return (React.createElement(AutocompleteField, { key: `${formObj.apiFieldName}-${id}`, type: "text", name: formObj.apiFieldName, id: id, value: additionalInfo[formObj.apiFieldName], placeholder: formObj.placeholder, label: formObj.name, onChange: (e) => handleOnValChange(e), onPlaceSelected: handlePlaceSelected, onBlur: (e) => handleOnInputBlur(e), error: Boolean(additionalInfoErrors[formObj.apiFieldName]), error_message: additionalInfoErrors[formObj.apiFieldName], isMandatoryField: formObj.required, CusIndex: 0, valueObj: additionalInfo }));
                }
                return (React.createElement(TextField, { label: formObj.name, name: formObj.apiFieldName, isMandatoryField: formObj.required, placeholder: formObj.placeholder, fullWidth: true, type: "text", value: additionalInfo[formObj.apiFieldName], onChange: (e) => handleOnValChange(e), onBlur: (e) => handleOnInputBlur(e), error: Boolean(additionalInfoErrors[formObj.apiFieldName]), error_message: additionalInfoErrors[formObj.apiFieldName], maxLength: getFormFieldInputMaxLength(formObj.apiFieldName), minLength: formObj.apiFieldName === 'SSN' ? 2 : undefined, regExp: getFormFieldRegEx(formObj.apiFieldName), startAdornment: formObj.startAdornment, endAdornment: Boolean(formObj.toolTipMsg) &&
                        React.createElement(InputAdornment, { position: "end" },
                            React.createElement(IconButton, { edge: "end" },
                                React.createElement(Tooltip, { title: formObj.toolTipMsg },
                                    React.createElement(InfoIcon, { sx: { fontSize: 18 } })))) }));
            case 'dropdown':
                return (React.createElement(AutoCompleteDD, { options: ((_a = formObj === null || formObj === void 0 ? void 0 : formObj.dropdownOptions) === null || _a === void 0 ? void 0 : _a.length) > 0 ? formObj.dropdownOptions : getDropdownOptions(formObj.apiFieldName), displayKey: (_b = formObj.dropdownOptionDisplayKey) !== null && _b !== void 0 ? _b : 'label', valueKey: (_c = formObj.dropdownOptionValueKey) !== null && _c !== void 0 ? _c : 'value', label: formObj.name, placeholder: formObj.placeholder, handleChange: (e) => handleOnValChange(e), selectedValue: getSelectedStateObject(additionalInfo[formObj.apiFieldName], formObj.apiFieldName, formObj.dropdownOptions), name: formObj.apiFieldName, errorMessage: additionalInfoErrors[formObj.apiFieldName], isMandatoryField: formObj.required, handleBlur: (e) => handleOnInputBlur(e), hasToolTip: Boolean(formObj.toolTipMsg), toolTipInfo: formObj.toolTipMsg, showClearIcon: (formObj === null || formObj === void 0 ? void 0 : formObj.apiFieldName) === 'Suffix' }));
            case 'date':
                return (React.createElement(Box, { className: 'filtr-date-pkr signup_date' },
                    React.createElement(MUIDatePicker, { labelText: formObj.name, selectedDate: additionalInfo[formObj.apiFieldName], dateChangeHandler: (value) => handleDateChange(formObj.apiFieldName, value), errorMessage: additionalInfoErrors[formObj.apiFieldName], isMandatory: formObj.required, clearDate: () => setAdditionalInfo((prevState) => (Object.assign(Object.assign({}, prevState), { [formObj.apiFieldName]: null }))), disableFuture: (formObj === null || formObj === void 0 ? void 0 : formObj.apiFieldName) === 'DOB' })));
        }
    };
    const signupFeilds = {
        '& .MuiGrid-container': {
            '& .MuiGrid-item': {
                '& .MuiFormControl-root': {
                    '& .MuiFormLabel-root': {
                        fontSize: '12px',
                    },
                }
            }
        }
    };
    const labelSpacing = (value) => {
        return {
            paddingRight: value.apiFieldName === 'DOB' || value.apiFieldName === 'BusinessIncorporatedDate' || value.apiFieldName === 'CustCountry' || value.apiFieldName === 'Country' || value.apiFieldName === 'City' ? '6px' : '',
            paddingLeft: value.apiFieldName === 'SSN' || value.apiFieldName === 'PostalCode' || value.apiFieldName === 'State' || value.apiFieldName === 'CustState' ? '6px' : '',
        };
    };
    return (React.createElement(Box, { sx: { width: '100%', overflow: 'hidden', overflowY: 'auto', signupFeilds }, mt: '16px', className: "signup_feilds" },
        React.createElement(Grid, { container: true, alignContent: 'flex-start', sx: {
                width: '100%', height: '100%',
                paddingRight: '16px',
                boxSizing: 'content-box'
            } },
            React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, pb: '16px', sx: {
                    '& .MuiFormGroup-root': {
                        gap: '16px'
                    }
                } },
                React.createElement(FormControl, null,
                    React.createElement(RadioGroup, { row: true, "aria-labelledby": "demo-row-radio-buttons-group-label", name: "BusOrInd", value: additionalInfo['BusOrInd'], onChange: (e) => handleOnValChange(e) },
                        !((_a = vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.Programs) === null || _a === void 0 ? void 0 : _a.every((program) => { var _a, _b; return (_b = (_a = program === null || program === void 0 ? void 0 : program.Name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes('consumer'); })) &&
                            React.createElement(FormControlLabel, { value: "B", control: React.createElement(Radio, null), label: t("CREATE_NOR_LOC_APP.GUR_INFO.BUSS") }),
                        ((_b = vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.Programs) === null || _b === void 0 ? void 0 : _b.some((program) => { var _a, _b; return (_b = (_a = program === null || program === void 0 ? void 0 : program.Name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes('consumer'); })) &&
                            React.createElement(FormControlLabel, { value: "I", control: React.createElement(Radio, null), label: t("CREATE_NOR_LOC_APP.GUR_INFO.IND") })))),
            (additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.BusOrInd) == 'I' ?
                React.createElement(React.Fragment, null, (_c = singupAdditionalInfoFields === null || singupAdditionalInfoFields === void 0 ? void 0 : singupAdditionalInfoFields['Individual Details']) === null || _c === void 0 ? void 0 : _c.map((indFormField, index) => (React.createElement(React.Fragment, null, !(indFormField === null || indFormField === void 0 ? void 0 : indFormField.hideField) &&
                    React.createElement(Grid, { key: `index${index}`, item: true, xs: 12, sm: (indFormField.apiFieldName === 'DOB' || indFormField.apiFieldName === 'SSN') ? 6 : 12, pb: '16px', sx: labelSpacing(indFormField) }, getFormFieldToRender(indFormField))))))
                :
                    React.createElement(React.Fragment, null, (_d = singupAdditionalInfoFields === null || singupAdditionalInfoFields === void 0 ? void 0 : singupAdditionalInfoFields['Business Details']) === null || _d === void 0 ? void 0 : _d.map((busFormField, index) => (React.createElement(React.Fragment, null, !(busFormField === null || busFormField === void 0 ? void 0 : busFormField.hideField) &&
                        React.createElement(Grid, { key: `index${index}`, item: true, xs: 12, sm: (busFormField.apiFieldName === 'BusinessIncorporatedDate' || busFormField.apiFieldName === 'SSN' || busFormField.apiFieldName === 'CustState' || busFormField.apiFieldName === 'CustCountry') ? 6 : 12, pb: '16px', sx: labelSpacing(busFormField) }, getFormFieldToRender(busFormField)))))),
            React.createElement(React.Fragment, null,
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'baseline', gap: 1, width: '100%', borderBottom: '1px solid', borderColor: 'primary.main', pb: '2px', mb: '16px' } },
                    React.createElement(Typography, { variant: 'h3', fontWeight: 600, fontSize: { xs: '14px', sm: '14px', md: '14px' }, sx: { color: 'primary.main' } }, t("CREATE_NOR_LOC_APP.GUR_INFO.AddressDetails")),
                    additionalInfo.__isAddressVerified && (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5, pb: '2px' } },
                        React.createElement(CheckCircleIcon, { sx: { fontSize: { xs: '12px', sm: '14px' }, color: '#4caf50' } }),
                        React.createElement(Typography, { sx: {
                                fontSize: { xs: '10px', sm: '11px' },
                                fontWeight: 500,
                                color: '#4caf50',
                                lineHeight: 1.4
                            } }, t("CREATE_NOR_LOC_APP.customer_info.GoogleVerifiedAddress"))))), (_e = singupAdditionalInfoFields === null || singupAdditionalInfoFields === void 0 ? void 0 : singupAdditionalInfoFields['Address Details']) === null || _e === void 0 ? void 0 :
                _e.map((formField, index) => (React.createElement(React.Fragment, null, !(formField === null || formField === void 0 ? void 0 : formField.hideField) &&
                    React.createElement(Grid, { key: `index${index}`, item: true, xs: 12, sm: (formField.apiFieldName === 'City' || formField.apiFieldName === 'PostalCode' || formField.apiFieldName === 'State' || formField.apiFieldName === 'Country') ? 6 : 12, pb: '16px', sx: Object.assign(Object.assign({}, labelSpacing(formField)), { '& .MuiFormControl-root.outlined-text-field': {
                                width: '100%'
                            } }) }, getFormFieldToRender(formField)))))),
            React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 12, pb: '16px' },
                React.createElement(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1.5 },
                    React.createElement(Button, { fullWidth: true, variant: 'outlined', className: 'ml-2 btn-primary', onClick: handlePreviousStep }, "Back"),
                    React.createElement(Button, { fullWidth: true, className: 'ml-2 btn-primary', variant: "contained", onClick: handleSubmit }, "Register"))))));
};
export default AdditionalInformation;
